/* ==========================================================================
   Bevegelse: seksjoner og kort toner inn første gang de kommer til syne.

   Det eneste skriptet for bevegelse i temaet (erstatter gs-forside.js og
   Dawns animations.js, som er slått av med animations_reveal_on_scroll).

   Spilleregler:
   - Én gang per element. Det som er sett, blir stående. Ikke koblet til
     rulleposisjonen: en CSS-tidslinje (view()) skjuler seksjonene igjen når
     man ruller tilbake, og et skjermbilde av hele siden ble tomt.
   - Bare det som ligger UNDER første skjerm røres. Det som er synlig ved
     innlasting får ingen klasse, så LCP og første inntrykk er uberørt.
   - Bare transform og opacity i CSS (assets/gs-bevegelse.css): ingen
     layoutforskyvning, ingen CLS.
   - Uten JS, uten IntersectionObserver og med «reduser bevegelse» skjules
     ingenting. Klassene settes bare av dette skriptet.
   - Ryddes bort når overgangen er ferdig, så elementets egne overganger
     (hover, fokus) ikke arver forsinkelsen.
   - Produktrutenettet på kategori- og søkesider er bevisst IKKE med: den som
     blar fort skal ikke møte tomme ruter (Dawns reveal ga 0,7 s usynlige
     kort), og filtrering bytter ut hele rutenettet via AJAX.
   ========================================================================== */
(function () {
  if (window.__gsBevegelse) return;
  window.__gsBevegelse = true;

  var reduser = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduser || !('IntersectionObserver' in window)) return;

  /* Hele elementet toner inn. */
  var ENKEL = [
    /* forsiden */
    '.gs-katkort__overskrift',
    '.gs-katseksjon__rad', '.gs-katseksjon__band',
    '.gs-historie__media', '.gs-historie__aar', '.gs-historie__tekst',
    /* produktsiden: beskrivelsen under kjøpsboksen */
    '.gs-pd__inner',
    /* om oss og optikerens tekstseksjoner */
    '.gs-om__fakta',
    '.gs-tb__topp', '.gs-tb__media', '.gs-tb__tekst'
  ].join(',');

  /* Barna toner inn etter hverandre (60 ms mellom hver, maks seks trinn). */
  var BARN = [
    '.gs-katkort__rutenett',
    '.gs-tillit__liste',
    '.gs-katseksjon__rutenett',
    '.gs-katseksjon__snarveier > ul'
  ].join(',');

  var TRINN_MS = 60;
  var MAKS_TRINN = 5;
  var slow = 380; /* --gs-slow */

  var iakttaker = new IntersectionObserver(function (poster) {
    poster.forEach(function (p) {
      if (!p.isIntersecting) return;
      var el = p.target;
      iakttaker.unobserve(el);
      el.classList.add('gs-inn--ja');
      var barn = el.classList.contains('gs-inn-barn');
      var varighet = slow + (barn ? MAKS_TRINN * TRINN_MS : 0) + 120;
      window.setTimeout(function () {
        el.classList.remove('gs-inn', 'gs-inn-barn', 'gs-inn--ja');
        if (barn) {
          for (var i = 0; i < el.children.length; i++) el.children[i].style.removeProperty('--gs-i');
        }
      }, varighet);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

  function utenfor(el) {
    var r = el.getBoundingClientRect();
    /* Ikke noe å vise: tomt eller skjult (display: none gir 0 x 0). */
    if (r.width === 0 && r.height === 0) return false;
    return !(r.top < window.innerHeight * 0.94 && r.bottom > 0);
  }

  function merk(el, barn) {
    if (el.hasAttribute('data-gs-inn')) return;
    el.setAttribute('data-gs-inn', '');
    if (!utenfor(el)) return;
    if (barn) {
      el.classList.add('gs-inn-barn');
      for (var i = 0; i < el.children.length; i++) {
        el.children[i].style.setProperty('--gs-i', Math.min(i, MAKS_TRINN));
      }
    } else {
      el.classList.add('gs-inn');
    }
    iakttaker.observe(el);
  }

  function skann(rot) {
    var r = rot || document;
    r.querySelectorAll(ENKEL).forEach(function (el) { merk(el, false); });
    r.querySelectorAll(BARN).forEach(function (el) { merk(el, true); });
  }

  skann();
  document.addEventListener('shopify:section:load', function (e) { skann(e.target); });
})();
